import { ThemeContext } from "@react-navigation/native";
import { useContext } from "react";
const isCustomTheme = (theme) => {
    return (theme !== undefined &&
        typeof theme === "object" &&
        "colors" in theme &&
        "info" in theme.colors &&
        "success" in theme.colors &&
        "warning" in theme.colors &&
        "danger" in theme.colors &&
        "sectionBackground" in theme.colors &&
        "tableRowHover" in theme.colors &&
        "menuA" in theme.colors &&
        "menuB" in theme.colors &&
        "menuD" in theme.colors);
};
export const useCustomTheme = () => {
    const theme = useContext(ThemeContext);
    if (!isCustomTheme(theme)) {
        throw new Error("useCustomTheme must be used within a ThemeProvider or NavigationContainer with a theme");
    }
    return theme;
};
//# sourceMappingURL=useCustomTheme.js.map